import { useTheme } from "../Theme/ThemeContext";

const ICONS = () => {
  const { isDark: isDarkModeActivated } = useTheme();
  const LightNavigationIcon = `${process.env.PUBLIC_URL}/assets/images/Navigation_icon.svg`;
  const DarkNavigationIcon = `${process.env.PUBLIC_URL}/assets/images/navigation_icon_dark.svg`;
  const Avatar = `${process.env.PUBLIC_URL}/assets/images/download.jpeg`;
  const ForumImg = `${process.env.PUBLIC_URL}/assets/images/forum.svg`;
  const ThreeDotsImg = `${process.env.PUBLIC_URL}/assets/images/threedot.svg`;
  const Bot = `${process.env.PUBLIC_URL}/assets/images/Bot.svg`;
  const BookSearch = `${process.env.PUBLIC_URL}/assets/images/BookSearch.svg`;
  const Comment = `${process.env.PUBLIC_URL}/assets/images/Comment.svg`;
  const LbmcLogo = `${process.env.PUBLIC_URL}/assets/images/lbmcLogo (1).svg`;
  const ChevronIcon = `${process.env.PUBLIC_URL}/assets/images/chevron_right.svg`;
  const DoneIcon = `${process.env.PUBLIC_URL}/assets/images/Done.svg`;
  const DarkDoneIcon = `${process.env.PUBLIC_URL}/assets/images/Done_Dark.svg`;
  const AccountIcon = `${process.env.PUBLIC_URL}/assets/images/account_icon.svg`;
  const UpdateConversationIcon = `${process.env.PUBLIC_URL}/assets/images/update-conversation.svg`;
  const LightEditConversationTitle = `${process.env.PUBLIC_URL}/assets/images/edit_conversation_title.svg`;
  const DarkEditConversationTitle = `${process.env.PUBLIC_URL}/assets/images/edit_conversation_title_dark.svg`;
  const Light_Newchat = `${process.env.PUBLIC_URL}/assets/images/New_chat.svg`;
  const Dark_Newchat = `${process.env.PUBLIC_URL}/assets/images/New_chat_dark.svg`;
  const Light_recent_conversation = `${process.env.PUBLIC_URL}/assets/images/recent_conversation_icon.svg`;
  const Dark_recent_conversation = `${process.env.PUBLIC_URL}/assets/images/recent_conversation_icon_dark.svg`;
  const Light_archieve_conversation = `${process.env.PUBLIC_URL}/assets/images/archieve_conversation_sidebar.svg`;
  const Dark_archieve_conversation = `${process.env.PUBLIC_URL}/assets/images/archieve_conversation_sidebar_dark.svg`;
  const Light_dark_mode = `${process.env.PUBLIC_URL}/assets/images/dark_mode_icon.svg`;
  const Dark_dark_mode = `${process.env.PUBLIC_URL}/assets/images/sun_icon_LightTheme.svg`;
  const Light_help_icon = `${process.env.PUBLIC_URL}/assets/images/help_icon.svg`;
  const Dark_help_icon = `${process.env.PUBLIC_URL}/assets/images/help_icon_dark.svg`;
  const Light_logout = `${process.env.PUBLIC_URL}/assets/images/logout_session.svg`;
  const Dark_logout = `${process.env.PUBLIC_URL}/assets/images/logout_session_dark.svg`;
  const LightPanelClose = `${process.env.PUBLIC_URL}/assets/images/pannelClose.svg`;
  const DarkPanelClose = `${process.env.PUBLIC_URL}/assets/images/pannelClose_dark.svg`;
  const LightResearchIcon = `${process.env.PUBLIC_URL}/assets/images/Index_search.svg`;
  const LightRemoveFromArchive = `${process.env.PUBLIC_URL}/assets/images/remove_from_archieve.svg`;
  const DarkRemoveFromArchive = `${process.env.PUBLIC_URL}/assets/images/remove_from_archieve_dark.svg`;
  const LightdismissIcon = `${process.env.PUBLIC_URL}/assets/images/Dismiss.svg`;
  const DarkdismissIcon = `${process.env.PUBLIC_URL}/assets/images/dismiss_dark.svg`;
  const AnswerIcon = `${process.env.PUBLIC_URL}/assets/images/answer_icon.svg`;
  const LightNewTabIcon = `${process.env.PUBLIC_URL}/assets/images/New-tab.svg`;
  const LightStarResponseOutlineIcon = `${process.env.PUBLIC_URL}/assets/images/Star_response_outline.svg`;
  const LightStarResponseFilledIcon = `${process.env.PUBLIC_URL}/assets/images/Filled_star.svg`;
  const LightLikeIcon = `${process.env.PUBLIC_URL}/assets/images/Like.svg`;
  const LightDisLikeIcon = `${process.env.PUBLIC_URL}/assets/images/Dislike.svg`;
  const LightCopyIcon = `${process.env.PUBLIC_URL}/assets/images/Copy.svg`;
  const DarkCopyIcon = `${process.env.PUBLIC_URL}/assets/images/Copy_dark.svg`;
  const LightShareIcon = `${process.env.PUBLIC_URL}/assets/images/Share.svg`;
  const LightThoughtProcessIcon = `${process.env.PUBLIC_URL}/assets/images/Thought_process.svg`;
  const LightRegenerateResponseIcon = `${process.env.PUBLIC_URL}/assets/images/regenerate_response.svg`;
  const LightLikeIconFilled = `${process.env.PUBLIC_URL}/assets/images/Filled_like.svg`;
  const LightDisLikeIconFilled = `${process.env.PUBLIC_URL}/assets/images/thumb_down_fill.svg`;
  const LightCloseIcon = `${process.env.PUBLIC_URL}/assets/images/close.svg`;
  const Light_sidebararchieve_conversation = `${process.env.PUBLIC_URL}/assets/images/archieveconversation_secondary_light.svg`;
  const Dark_sidebararchieve_conversation = `${process.env.PUBLIC_URL}/assets/images/archieveconversation_secondaryside_dark.svg`;
  const DraftSummary = `${process.env.PUBLIC_URL}/assets/images/DocumentText.svg`;
  const Draftnotes = `${process.env.PUBLIC_URL}/assets/images/Notepad.svg`;
  const Draftemail = `${process.env.PUBLIC_URL}/assets/images/Mail.svg`;
  const Drafticon = `${process.env.PUBLIC_URL}/assets/images/DraftIcon.svg`;
  const Brainicon = `${process.env.PUBLIC_URL}/assets/images/Brain-icon-gray.svg`;
  const fileupload = `${process.env.PUBLIC_URL}/assets/images/Attach.svg`;


  return isDarkModeActivated
    ? {
        Avatar: Avatar,
        ForumImg: ForumImg,
        ThreeDotsImg: ThreeDotsImg,
        NewChatImg: Dark_Newchat,
        RecentConversationImg: Dark_recent_conversation,
        ArchieveConversationImg: Dark_archieve_conversation,
        DarkModeImg: Dark_dark_mode,
        HelpImg: Dark_help_icon,
        LogoutImg: Dark_logout,
        PanelCloseImg: DarkPanelClose,
        ResearchIcon: LightResearchIcon,
        BotIcon: Bot,
        BookSearchIcon: BookSearch,
        CommentIcon: Comment,
        LbmcLogoImg: LbmcLogo,
        ChevronIcon: ChevronIcon,
        EditConversationTitle: DarkEditConversationTitle,
        RemoveFromArchive: DarkRemoveFromArchive,
        dismissIcon: DarkdismissIcon,
        AnswerIcon: AnswerIcon,
        NewTabIcon: LightNewTabIcon,
        StarResponseOutlineIcon: LightStarResponseOutlineIcon,
        StarResponseFilledIcon: LightStarResponseFilledIcon,
        LikeIcon: LightLikeIcon,
        DisLikeIcon: LightDisLikeIcon,
        CopyIcon: DarkCopyIcon,
        ShareIcon: LightShareIcon,
        ThoughtProcessIcon: LightThoughtProcessIcon,
        RegenerateResponseIcon: LightRegenerateResponseIcon,
        LikeIconFilled: LightLikeIconFilled,
        DisLikeIconFilled: LightDisLikeIconFilled,
        NavigationIcon: DarkNavigationIcon,
        DoneIcon: DarkDoneIcon,
        AccountIcon: AccountIcon,
        UpdateConversationIcon: UpdateConversationIcon,
        LightCloseIcon: LightCloseIcon,
        SidebarArchieveConversationImg:Dark_sidebararchieve_conversation,
        DraftSummary:DraftSummary,
        Draftnotes:Draftnotes,
        Draftemail:Draftemail,
        Drafticon:Drafticon,
        Brainicon: Brainicon,
        fileupload: fileupload,
      }
    : {
        Avatar: Avatar,
        ForumImg: ForumImg,
        ThreeDotsImg: ThreeDotsImg,
        NewChatImg: Light_Newchat,
        RecentConversationImg: Light_recent_conversation,
        ArchieveConversationImg: Light_archieve_conversation,
        DarkModeImg: Light_dark_mode,
        HelpImg: Light_help_icon,
        LogoutImg: Light_logout,
        PanelCloseImg: LightPanelClose,
        ResearchIcon: LightResearchIcon,
        BotIcon: Bot,
        BookSearchIcon: BookSearch,
        CommentIcon: Comment,
        LbmcLogoImg: LbmcLogo,
        ChevronIcon: ChevronIcon,
        EditConversationTitle: LightEditConversationTitle,
        RemoveFromArchive: LightRemoveFromArchive,
        dismissIcon: LightdismissIcon,
        AnswerIcon: AnswerIcon,
        NewTabIcon: LightNewTabIcon,
        StarResponseOutlineIcon: LightStarResponseOutlineIcon,
        StarResponseFilledIcon: LightStarResponseFilledIcon,
        LikeIcon: LightLikeIcon,
        DisLikeIcon: LightDisLikeIcon,
        CopyIcon: LightCopyIcon,
        ShareIcon: LightShareIcon,
        ThoughtProcessIcon: LightThoughtProcessIcon,
        RegenerateResponseIcon: LightRegenerateResponseIcon,
        LikeIconFilled: LightLikeIconFilled,
        DisLikeIconFilled: LightDisLikeIconFilled,
        NavigationIcon: LightNavigationIcon,
        DoneIcon: DoneIcon,
        AccountIcon: AccountIcon,
        UpdateConversationIcon: UpdateConversationIcon,
        LightCloseIcon: LightCloseIcon,
        SidebarArchieveConversationImg:Light_sidebararchieve_conversation,
        DraftSummary:DraftSummary,
        Draftnotes:Draftnotes,
        Draftemail:Draftemail,
        Drafticon:Drafticon,
        Brainicon: Brainicon,
        fileupload: fileupload, 
      };
};

export default ICONS;
